import { ThemeUICSSObject } from 'theme-ui';
import common from './common';

const primary: ThemeUICSSObject = {
  ...common('components.paginationSecondary'),
};

export default primary;
